import { memo, useCallback, useState } from "react";
import * as Styled from "./style";
import { VideoSpotLiveSeasonTabContents } from "./video-spot-live-season-tab-contents";
import { VideoSpotLiveSeasonTabTitle } from "./video-spot-live-season-tab-title";
import { SPOT_LIVE_SELECT_TABS } from "~/components/blocks/product/const";
import type { G_GetVideoQuery } from "~/lib/graphql";

type VideoSpotLiveSeasonTabProps = {
  videoData: G_GetVideoQuery["video"];
};

/**
 * 作品末端 | スポット配信 | タブとそのタブに紐づくコンテンツを表示するコンポーネント
 * @param props {@link VideoSpotLiveSeasonTabProps}
 */
export const VideoSpotLiveSeasonTab = memo((props: VideoSpotLiveSeasonTabProps) => {
  const { videoData } = props;

  const [selectedTabValue, setSelectedTabValue] = useState(SPOT_LIVE_SELECT_TABS.PRODUCT_INFO);

  const onChangeTabValue = useCallback((v: string) => {
    setSelectedTabValue(v);
  }, []);

  // MEMO : エピソードタブは初期リリースからはスコープアウトなのでコメントアウト
  // const isomorphicEffect = useIsomorphicEffect();

  // const [totalMainEpisodeCount, setTotalMainEpisodeCount] = useState(0);

  // const onTotalMainEpisodeChange = useCallback((totalCount: number) => {
  //   setTotalMainEpisodeCount(totalCount);
  // }, []);

  // const effectInitialTabTitle = () => {
  //   if (totalMainEpisodeCount > 1 && videoData.seasonType === G_VideoSeasonType.MultiEpisodes) {
  //     setSelectedTabValue(SPOT_LIVE_SELECT_TABS.EPISODE);
  //     return;
  //   }

  //   setSelectedTabValue(SPOT_LIVE_SELECT_TABS.PRODUCT_INFO);
  // };

  // isomorphicEffect(effectInitialTabTitle, [totalMainEpisodeCount]);

  return (
    <Styled.ArticleRootTab>
      <VideoSpotLiveSeasonTabTitle selectedTabValue={selectedTabValue} onChangeTabValue={onChangeTabValue} />

      <VideoSpotLiveSeasonTabContents
        videoData={videoData}
        selectedTabValue={selectedTabValue}
        // totalEpisodeLength={totalMainEpisodeCount}
        // onTotalMainEpisodeChange={onTotalMainEpisodeChange}
      />
    </Styled.ArticleRootTab>
  );
});

VideoSpotLiveSeasonTab.displayName = "VideoSeasonTab";
